// tokenService.ts
type TokenChangeListener = (token: string | null) => void;

let accessToken: string | null = null;
let listeners: TokenChangeListener[] = [];
let isAdminViewSession = false;

export const getAccessToken = (): string | null => accessToken;

export const setAccessToken = (token: string | null) => {
  if (accessToken === token) return; // Prevent unnecessary updates

  accessToken = token;

  // Notify all listeners
  listeners.forEach((listener) => {
    try {
      listener(token);
    } catch (error) {
      console.error("Error in token change listener:", error);
    }
  });
};

export const getIsAdminView = (): boolean => isAdminViewSession;
export const setIsAdminView = (value: boolean) => {
  isAdminViewSession = value;
};

export const clearTokens = () => {
  setAccessToken(null);
  isAdminViewSession = false;
};

export const onAccessTokenChange = (
  callback: TokenChangeListener
): (() => void) => {
  listeners.push(callback);

  // Return unsubscribe function
  return () => {
    listeners = listeners.filter((cb) => cb !== callback);
  };
};
